import { Observable } from "rxjs";

export interface BALObserverModel {
    balObservable: Observable<BALData>
};

export interface BALRareStreamData {
    [x: string]: string
};

export enum BALParameters {
    BU = 'BU',
    BR = 'BR',
};

export interface GroupedBALStreamData {
    finalOutputFanSpeed: string | number,
    historianFanSpeed: string | number,
    airTempAverage: string | number,
    tobTempAverage: string | number,
    tobAirDeviation: string,
    airTobaccoTemperatureSP: string | number,
    isBreakdown?: boolean,
    IsHistSampling?: boolean,
};

export interface BALParsedStreamData {
    BC: GroupedBALStreamData,
    BS: GroupedBALStreamData,
}
export type BALData = BALParsedStreamData